import provide from './provide';
import transformers from './transformers';
import Filter from './Filter.vue';

export default {
  provide,
  transformers,
  Filter,
};
